/**
 * Created by zhengyf on 2017/11/23.
 */

;(function () {

    var infoDisplayConfig = {
        "title": {
            "text": "分",
            "x": 62,
            "y": 36,
            "textStyle": {
                "color": "#A4A4A4",
                "fontSize": 12,
                "fontFamily": "微软雅黑",
                "fontWeight": "bolder",
                "decoration": "none",
                "fontFamily2": "微软雅黑",
                "fontStyle": "normal"
            },
            "subtext": "",
            "backgroundColor": "rgba(0,0,0,0)",
            "borderColor": "#ccc",
            "borderWidth": 0,
            "padding": [5, 5, 5, 5],
            "itemGap": 5,
            "subtextStyle": {
                "color": "#aaa",
                "decoration": "none",
                "fontFamily": "Arial, Verdana, sans-serif",
                "fontFamily2": "微软雅黑",
                "fontSize": 12,
                "fontStyle": "normal",
                "fontWeight": "normal"
            }
        },
        "series": [{
            "name": "业务指标",
            "type": "gauge",
            "radius": 48,
            "splitNumber": 1,
            "axisLine": {
                "lineStyle": {
                    "width": 6,
                    "color": [[0.4666666666666667, "#75BDFF"], [0.9999, "#EBECF0"], [1, "#EBECF0"]]
                }, "show": true
            },
            "axisTick": {
                "show": false,
                "splitNumber": 5,
                "length": 8,
                "lineStyle": {"color": "#eee", "width": 1, "type": "solid"}
            },
            "axisLabel": {"textStyle": {"color": "#ccc", "fontSize": 12, "padding": [2, 2, 8, 2]}, "show": true},
            "splitLine": {"show": false, "length": -6, "lineStyle": {"color": "#eee", "width": 2, "type": "solid"}},
            "pointer": {"width": 0, "show": false, "length": "80%", "color": "auto"},
            "title": {
                "show": true,
                "offsetCenter": [0, 12],
                "textStyle": {"fontWeight": "bolder", "fontSize": 12, "color": "auto", "fontFamily": "微软雅黑"}
            },
            "detail": {
                "formatter": "{value}",
                "offsetCenter": [-7, -18],
                "textStyle": {"color": "black", "fontSize": 30, "fontWeight": "bold", "align": "left"},
                "width": 30,
                "height": 18,
                "borderWidth": 0,
                "borderColor": "black",
                "show": true,
                "backgroundColor": "rgba(0,0,0,0)"
            },
            "max": 30,
            "data": [{"value": 14, "name": "一般"}],
            "center": ["50%", "50%"],
            "legendHoverLink": true,
            "startAngle": 225,
            "endAngle": -45,
            "min": 0,
            "precision": 0
        }],
        "DRAG_ENABLE_TIME": 120,
        "symbolList": ["circle", "rectangle", "triangle", "diamond", "emptyCircle", "emptyRectangle", "emptyTriangle", "emptyDiamond"],
        "addDataAnimation": true,
        "animationEasing": "ExponentialOut",
        "animationDuration": 2000,
        "animationThreshold": 2000,
        "animation": true,
        "valueConnector": ": ",
        "nameConnector": " & ",
        "calculableHolderColor": "#ccc",
        "calculableColor": "rgba(255,165,0,0.6)",
        "calculable": false,
        "backgroundColor": "rgba(0,0,0,0)",
        "island": {"r": 15, "calculateStep": 0.1},
        "toolbox": {
            "show": false,
            "orient": "horizontal",
            "x": "right",
            "y": "top",
            "color": ["#1e90ff", "#22bb22", "#4b0082", "#d2691e"],
            "disableColor": "#ddd",
            "effectiveColor": "red",
            "backgroundColor": "rgba(0,0,0,0)",
            "borderColor": "#ccc",
            "borderWidth": 0,
            "padding": [5, 5, 5, 5],
            "itemGap": 10,
            "itemSize": 16,
            "showTitle": true,
            "feature": {
                "mark": {
                    "show": false,
                    "title": {"mark": "辅助线开关", "markUndo": "删除辅助线", "markClear": "清空辅助线"},
                    "lineStyle": {"width": 1, "color": "#1e90ff", "type": "dashed"}
                },
                "dataZoom": {"show": false, "title": {"dataZoom": "区域缩放", "dataZoomReset": "区域缩放后退"}},
                "dataView": {
                    "show": false,
                    "title": "数据视图",
                    "readOnly": false,
                    "lang": ["Data View", "close", "refresh"]
                },
                "magicType": {
                    "show": false,
                    "title": {"line": "折线图切换", "bar": "柱形图切换", "stack": "堆积", "tiled": "平铺"},
                    "type": []
                },
                "restore": {"show": false, "title": "还原"},
                "saveAsImage": {"show": false, "title": "保存为图片", "type": "png", "lang": ["点击保存"]}
            }
        }
    };

    var busObtainConfig = {
        "title": {
            "text": "分",
            "x": 62,
            "y": 36,
            "textStyle": {
                "color": "#A4A4A4",
                "fontSize": 12,
                "fontFamily": "微软雅黑",
                "fontWeight": "bolder",
                "decoration": "none",
                "fontFamily2": "微软雅黑",
                "fontStyle": "normal"
            },
            "subtext": "",
            "backgroundColor": "rgba(0,0,0,0)",
            "borderColor": "#ccc",
            "borderWidth": 0,
            "padding": [5, 5, 5, 5],
            "itemGap": 5,
            "subtextStyle": {
                "color": "#aaa",
                "decoration": "none",
                "fontFamily": "Arial, Verdana, sans-serif",
                "fontFamily2": "微软雅黑",
                "fontSize": 12,
                "fontStyle": "normal",
                "fontWeight": "normal"
            }
        },
        "series": [{
            "name": "业务指标",
            "type": "gauge",
            "radius": 48,
            "splitNumber": 1,
            "axisLine": {
                "lineStyle": {"width": 6, "color": [[0.72, "#2192D9"], [0.9999, "#EBECF0"], [1, "#EBECF0"]]},
                "show": true
            },
            "axisTick": {
                "show": false,
                "splitNumber": 5,
                "length": 8,
                "lineStyle": {"color": "#eee", "width": 1, "type": "solid"}
            },
            "axisLabel": {"textStyle": {"color": "#ccc", "fontSize": 12, padding: [2, 2, 8, 2]}, "show": true},
            "splitLine": {"show": false, "length": -6, "lineStyle": {"color": "#eee", "width": 2, "type": "solid"}},
            "pointer": {"width": 0, "show": false, "length": "80%", "color": "auto"},
            "title": {
                "show": true,
                "offsetCenter": [0, 12],
                "textStyle": {"fontWeight": "bolder", "fontSize": 12, "color": "auto", "fontFamily": "微软雅黑"}
            },
            "detail": {
                "formatter": "{value}",
                "offsetCenter": [-7, -18],
                "textStyle": {"color": "black", "fontSize": 30, "fontWeight": "bold", "align": "left"},
                "width": 30,
                "height": 18,
                "borderWidth": 0,
                "borderColor": "black",
                "show": true,
                "backgroundColor": "rgba(0,0,0,0)"
            },
            "max": 25,
            "data": [{"value": 18, "name": "良好"}],
            "center": ["50%", "50%"],
            "legendHoverLink": true,
            "startAngle": 225,
            "endAngle": -45,
            "min": 0,
            "precision": 0
        }],
        "DRAG_ENABLE_TIME": 120,
        "symbolList": ["circle", "rectangle", "triangle", "diamond", "emptyCircle", "emptyRectangle", "emptyTriangle", "emptyDiamond"],
        "addDataAnimation": true,
        "animationEasing": "ExponentialOut",
        "animationDuration": 2000,
        "animationThreshold": 2000,
        "animation": true,
        "valueConnector": ": ",
        "nameConnector": " & ",
        "calculableHolderColor": "#ccc",
        "calculableColor": "rgba(255,165,0,0.6)",
        "calculable": false,
        "backgroundColor": "rgba(0,0,0,0)",
        "island": {"r": 15, "calculateStep": 0.1},
        "toolbox": {
            "show": false,
            "orient": "horizontal",
            "x": "right",
            "y": "top",
            "color": ["#1e90ff", "#22bb22", "#4b0082", "#d2691e"],
            "disableColor": "#ddd",
            "effectiveColor": "red",
            "backgroundColor": "rgba(0,0,0,0)",
            "borderColor": "#ccc",
            "borderWidth": 0,
            "padding": [5, 5, 5, 5],
            "itemGap": 10,
            "itemSize": 16,
            "showTitle": true,
            "feature": {
                "mark": {
                    "show": false,
                    "title": {"mark": "辅助线开关", "markUndo": "删除辅助线", "markClear": "清空辅助线"},
                    "lineStyle": {"width": 1, "color": "#1e90ff", "type": "dashed"}
                },
                "dataZoom": {"show": false, "title": {"dataZoom": "区域缩放", "dataZoomReset": "区域缩放后退"}},
                "dataView": {
                    "show": false,
                    "title": "数据视图",
                    "readOnly": false,
                    "lang": ["Data View", "close", "refresh"]
                },
                "magicType": {
                    "show": false,
                    "title": {"line": "折线图切换", "bar": "柱形图切换", "stack": "堆积", "tiled": "平铺"},
                    "type": []
                },
                "restore": {"show": false, "title": "还原"},
                "saveAsImage": {"show": false, "title": "保存为图片", "type": "png", "lang": ["点击保存"]}
            }
        }
    };

    var busHandleConfig = {
        "title": {
            "text": "分",
            "x": 62,
            "y": 36,
            "textStyle": {
                "color": "#A4A4A4",
                "fontSize": 12,
                "fontFamily": "微软雅黑",
                "fontWeight": "bolder",
                "decoration": "none",
                "fontFamily2": "微软雅黑",
                "fontStyle": "normal"
            },
            "subtext": "",
            "backgroundColor": "rgba(0,0,0,0)",
            "borderColor": "#ccc",
            "borderWidth": 0,
            "padding": [5, 5, 5, 5],
            "itemGap": 5,
            "subtextStyle": {
                "color": "#aaa",
                "decoration": "none",
                "fontFamily": "Arial, Verdana, sans-serif",
                "fontFamily2": "微软雅黑",
                "fontSize": 12,
                "fontStyle": "normal",
                "fontWeight": "normal"
            }
        },
        "series": [{
            "name": "业务指标",
            "type": "gauge",
            "radius": 48,
            "splitNumber": 1,
            "axisLine": {
                "lineStyle": {"width": 6, "color": [[0.55, "#75BDFF"], [0.9999, "#EBECF0"], [1, "#EBECF0"]]},
                "show": true
            },
            "axisTick": {
                "show": false,
                "splitNumber": 5,
                "length": 8,
                "lineStyle": {"color": "#eee", "width": 1, "type": "solid"}
            },
            "axisLabel": {"textStyle": {"color": "#ccc", "fontSize": 12, padding: [2, 2, 8, 2]}, "show": true},
            "splitLine": {"show": false, "length": -6, "lineStyle": {"color": "#eee", "width": 2, "type": "solid"}},
            "pointer": {"width": 0, "show": false, "length": "80%", "color": "auto"},
            "title": {
                "show": true,
                "offsetCenter": [0, 12],
                "textStyle": {"fontWeight": "bolder", "fontSize": 12, "color": "auto", "fontFamily": "微软雅黑"}
            },
            "detail": {
                "formatter": "{value}",
                "offsetCenter": [-7, -18],
                "textStyle": {"color": "black", "fontSize": 30, "fontWeight": "bold", "align": "left"},
                "width": 30,
                "height": 18,
                "borderWidth": 0,
                "borderColor": "black",
                "show": true,
                "backgroundColor": "rgba(0,0,0,0)"
            },
            "max": 20,
            "data": [{"value": 11, "name": "一般"}],
            "center": ["50%", "50%"],
            "legendHoverLink": true,
            "startAngle": 225,
            "endAngle": -45,
            "min": 0,
            "precision": 0
        }],
        "DRAG_ENABLE_TIME": 120,
        "symbolList": ["circle", "rectangle", "triangle", "diamond", "emptyCircle", "emptyRectangle", "emptyTriangle", "emptyDiamond"],
        "addDataAnimation": true,
        "animationEasing": "ExponentialOut",
        "animationDuration": 2000,
        "animationThreshold": 2000,
        "animation": true,
        "valueConnector": ": ",
        "nameConnector": " & ",
        "calculableHolderColor": "#ccc",
        "calculableColor": "rgba(255,165,0,0.6)",
        "calculable": false,
        "backgroundColor": "rgba(0,0,0,0)",
        "island": {"r": 15, "calculateStep": 0.1},
        "toolbox": {
            "show": false,
            "orient": "horizontal",
            "x": "right",
            "y": "top",
            "color": ["#1e90ff", "#22bb22", "#4b0082", "#d2691e"],
            "disableColor": "#ddd",
            "effectiveColor": "red",
            "backgroundColor": "rgba(0,0,0,0)",
            "borderColor": "#ccc",
            "borderWidth": 0,
            "padding": [5, 5, 5, 5],
            "itemGap": 10,
            "itemSize": 16,
            "showTitle": true,
            "feature": {
                "mark": {
                    "show": false,
                    "title": {"mark": "辅助线开关", "markUndo": "删除辅助线", "markClear": "清空辅助线"},
                    "lineStyle": {"width": 1, "color": "#1e90ff", "type": "dashed"}
                },
                "dataZoom": {"show": false, "title": {"dataZoom": "区域缩放", "dataZoomReset": "区域缩放后退"}},
                "dataView": {
                    "show": false,
                    "title": "数据视图",
                    "readOnly": false,
                    "lang": ["Data View", "close", "refresh"]
                },
                "magicType": {
                    "show": false,
                    "title": {"line": "折线图切换", "bar": "柱形图切换", "stack": "堆积", "tiled": "平铺"},
                    "type": []
                },
                "restore": {"show": false, "title": "还原"},
                "saveAsImage": {"show": false, "title": "保存为图片", "type": "png", "lang": ["点击保存"]}
            }
        }
    };

    var onlineTradingConfig = {
        "title": {
            "text": "分",
            "x": 54,
            "y": 36,
            "textStyle": {
                "color": "#A4A4A4",
                "fontSize": 12,
                "fontFamily": "微软雅黑",
                "fontWeight": "bolder",
                "decoration": "none",
                "fontFamily2": "微软雅黑",
                "fontStyle": "normal"
            },
            "subtext": "",
            "backgroundColor": "rgba(0,0,0,0)",
            "borderColor": "#ccc",
            "borderWidth": 0,
            "padding": [5, 5, 5, 5],
            "itemGap": 5,
            "subtextStyle": {
                "color": "#aaa",
                "decoration": "none",
                "fontFamily": "Arial, Verdana, sans-serif",
                "fontFamily2": "微软雅黑",
                "fontSize": 12,
                "fontStyle": "normal",
                "fontWeight": "normal"
            }
        },
        "series": [{
            "name": "业务指标",
            "type": "gauge",
            "radius": 48,
            "splitNumber": 1,
            "axisLine": {
                "lineStyle": {"width": 6, "color": [[0.36, "#FF3333"], [0.9999, "#EBECF0"], [1, "#EBECF0"]]},
                "show": true
            },
            "axisTick": {
                "show": false,
                "splitNumber": 5,
                "length": 8,
                "lineStyle": {"color": "#eee", "width": 1, "type": "solid"}
            },
            "axisLabel": {"textStyle": {"color": "#ccc", "fontSize": 12, padding: [2, 2, 8, 2]}, "show": true},
            "splitLine": {"show": false, "length": -6, "lineStyle": {"color": "#eee", "width": 2, "type": "solid"}},
            "pointer": {"width": 0, "show": false, "length": "80%", "color": "auto"},
            "title": {
                "show": true,
                "offsetCenter": [0, 12],
                "textStyle": {"fontWeight": "bolder", "fontSize": 12, "color": "auto", "fontFamily": "微软雅黑"}
            },
            "detail": {
                "formatter": "{value}",
                "offsetCenter": [-7, -18],
                "textStyle": {"color": "black", "fontSize": 30, "fontWeight": "bold", "align": "left"},
                "width": 30,
                "height": 18,
                "borderWidth": 0,
                "borderColor": "black",
                "show": true,
                "backgroundColor": "rgba(0,0,0,0)"
            },
            "max": 25,
            "data": [{"value": 9, "name": "较差"}],
            "center": ["50%", "50%"],
            "legendHoverLink": true,
            "startAngle": 225,
            "endAngle": -45,
            "min": 0,
            "precision": 0
        }],
        "DRAG_ENABLE_TIME": 120,
        "symbolList": ["circle", "rectangle", "triangle", "diamond", "emptyCircle", "emptyRectangle", "emptyTriangle", "emptyDiamond"],
        "addDataAnimation": true,
        "animationEasing": "ExponentialOut",
        "animationDuration": 2000,
        "animationThreshold": 2000,
        "animation": true,
        "valueConnector": ": ",
        "nameConnector": " & ",
        "calculableHolderColor": "#ccc",
        "calculableColor": "rgba(255,165,0,0.6)",
        "calculable": false,
        "backgroundColor": "rgba(0,0,0,0)",
        "island": {"r": 15, "calculateStep": 0.1},
        "toolbox": {
            "show": false,
            "orient": "horizontal",
            "x": "right",
            "y": "top",
            "color": ["#1e90ff", "#22bb22", "#4b0082", "#d2691e"],
            "disableColor": "#ddd",
            "effectiveColor": "red",
            "backgroundColor": "rgba(0,0,0,0)",
            "borderColor": "#ccc",
            "borderWidth": 0,
            "padding": [5, 5, 5, 5],
            "itemGap": 10,
            "itemSize": 16,
            "showTitle": true,
            "feature": {
                "mark": {
                    "show": false,
                    "title": {"mark": "辅助线开关", "markUndo": "删除辅助线", "markClear": "清空辅助线"},
                    "lineStyle": {"width": 1, "color": "#1e90ff", "type": "dashed"}
                },
                "dataZoom": {"show": false, "title": {"dataZoom": "区域缩放", "dataZoomReset": "区域缩放后退"}},
                "dataView": {
                    "show": false,
                    "title": "数据视图",
                    "readOnly": false,
                    "lang": ["Data View", "close", "refresh"]
                },
                "magicType": {
                    "show": false,
                    "title": {"line": "折线图切换", "bar": "柱形图切换", "stack": "堆积", "tiled": "平铺"},
                    "type": []
                },
                "restore": {"show": false, "title": "还原"},
                "saveAsImage": {"show": false, "title": "保存为图片", "type": "png", "lang": ["点击保存"]}
            }
        }
    };

    var onlineChartConfig = {
        "title": {
            "x": 56,
            "y": 35,
            "text": "",
            "textStyle": {
                "fontSize": 12,
                "fontWeight": "bolder",
                "color": "#333",
                "decoration": "none",
                "fontFamily": "Arial, Verdana, sans-serif",
                "fontFamily2": "微软雅黑", "fontStyle": "normal"
            },
            "subtext": "",
            "backgroundColor": "rgba(0,0,0,0)",
            "borderColor": "#ccc",
            "borderWidth": 0,
            "padding": [5, 5, 5, 5],
            "itemGap": 5,
            "subtextStyle": {
                "color": "#aaa",
                "decoration": "none",
                "fontFamily": "Arial, Verdana, sans-serif",
                "fontFamily2": "微软雅黑",
                "fontSize": 12,
                "fontStyle": "normal",
                "fontWeight": "normal"
            }
        },
        "grid": {
            "borderWidth": 0,
            "x": 64,
            "x2": 0,
            "y": 60,
            "y2": 60,
            "backgroundColor": "rgba(0,0,0,0)",
            "borderColor": "#ccc"
        },
        "color": ["#ff8a00", "#00b5b7", "#1686cc"],
        "tooltip": {
            "trigger": "axis",
            "show": true,
            "showContent": true,
            "islandFormatter": "{a} <br/>{b} : {c}",
            "showDelay": 20,
            "hideDelay": 100,
            "transitionDuration": 0.4,
            "backgroundColor": "rgba(0,0,0,0.7)",
            "borderColor": "#333",
            "borderRadius": 4,
            "borderWidth": 0,
            "padding": [5, 5, 5, 5],
            "axisPointer": {
                "type": "line",
                "lineStyle": {
                    "color": "#48b",
                    "width": 2,
                    "type": "solid"
                },
                "crossStyle": {
                    "color": "#1e90ff",
                    "width": 1,
                    "type": "dashed"
                },
                "shadowStyle": {
                    "color": "rgba(150,150,150,0.3)",
                    "width": "auto",
                    "type": "default"
                }
            },
            "textStyle": {
                "color": "#fff",
                "decoration": "none",
                "fontFamily": "Arial, Verdana, sans-serif",
                "fontFamily2": "微软雅黑",
                "fontSize": 12,
                "fontStyle": "normal",
                "fontWeight": "normal"
            }
        },
        "legend": {
            "data": ["我的表现", "同行平均", "同行TOP10平均"],
            "x": "center",
            "y": "bottom",
            "itemWidth": 20,
            "itemHeight": 20,
            "orient": "horizontal",
            "backgroundColor": "rgba(0,0,0,0)",
            "borderColor": "#ccc",
            "borderWidth": 0,
            "padding": [5, 5, 5, 5],
            "itemGap": 10,
            "textStyle": {
                "color": "#333"
            },
            "selectedMode": true
        },
        "toolbox": {
            "show": false,
            "orient": "horizontal",
            "x": "right",
            "y": "top",
            "color": ["#1e90ff", "#22bb22", "#4b0082", "#d2691e"],
            "disableColor": "#ddd",
            "effectiveColor": "red",
            "backgroundColor": "rgba(0,0,0,0)",
            "borderColor": "#ccc",
            "borderWidth": 0,
            "padding": [5, 5, 5, 5],
            "itemGap": 10,
            "itemSize": 16,
            "showTitle": true,
            "feature": {
                "mark": {
                    "show": false,
                    "title": {
                        "mark": "辅助线开关",
                        "markUndo": "删除辅助线",
                        "markClear": "清空辅助线"
                    },
                    "lineStyle": {
                        "width": 1,
                        "color": "#1e90ff",
                        "type": "dashed"
                    }
                },
                "dataZoom": {
                    "show": false,
                    "title": {
                        "dataZoom": "区域缩放",
                        "dataZoomReset": "区域缩放后退"
                    }
                },
                "dataView": {
                    "show": false,
                    "title": "数据视图",
                    "readOnly": false,
                    "lang": ["Data View", "close", "refresh"]
                },
                "magicType":
                    {
                        "show": false,
                        "title": {
                            "line": "折线图切换",
                            "bar": "柱形图切换",
                            "stack": "堆积",
                            "tiled": "平铺"
                        },
                        "type": []
                    },
                "restore": {
                    "show": false,
                    "title": "还原"
                },
                "saveAsImage": {
                    "show": false,
                    "title": "保存为图片",
                    "type": "png",
                    "lang": ["点击保存"]
                }
            }
        },
        "calculable": true,
        "xAxis": [{
            "type": "category",
            "data": ["交易等级分"],
            "axisLine": {
                "show": false,
                "onZero": true,
                "lineStyle": {"color": "#48b", "width": 2, "type": "solid"}
            },
            "axisTick": {
                "show": false,
                "interval": "auto",
                "inside": false,
                "length": 5,
                "lineStyle": {"color": "#333", "width": 1}
            },
            "position": "bottom",
            "xAxisIndex": 0,
            "yAxisIndex": -1,
            "name": "",
            "nameLocation": "end",
            "nameTextStyle": {},
            "boundaryGap": true,
            "axisLabel": {
                "show": true,
                "interval": "auto",
                "rotate": 0,
                "margin": 8,
                "textStyle": {
                    "color": "#333",
                    "decoration": "none",
                    "fontFamily": "Arial, Verdana, sans-serif",
                    "fontFamily2": "微软雅黑",
                    "fontSize": 12,
                    "fontStyle": "normal",
                    "fontWeight": "normal"
                }
            },
            "splitLine": {"show": true, "lineStyle": {"color": ["#ccc"], "width": 1, "type": "solid"}},
            "splitArea": {"show": false, "areaStyle": {"color": ["rgba(250,250,250,0.3)", "rgba(200,200,200,0.3)"]}}
        }],
        "yAxis": [{
            "type": "value",
            "axisLine": {
                "show": false,
                "onZero": true,
                "lineStyle": {"color": "#48b", "width": 2, "type": "solid"}
            },
            "splitLine": {"lineStyle": {"color": ["#e6eefa"], "width": 1, "type": "solid"}, "show": true},
            "position": "left",
            "xAxisIndex": -1,
            "yAxisIndex": 0,
            "name": "",
            "nameLocation": "end",
            "nameTextStyle": {},
            "boundaryGap": [0, 0],
            "precision": 0,
            "power": 100,
            "splitNumber": 5,
            "axisTick": {"show": false, "inside": false, "length": 5, "lineStyle": {"color": "#333", "width": 1}},
            "axisLabel": {
                "show": true,
                "rotate": 0,
                "margin": 8,
                "textStyle": {
                    "color": "#333",
                    "decoration": "none",
                    "fontFamily": "Arial, Verdana, sans-serif",
                    "fontFamily2": "微软雅黑",
                    "fontSize": 12,
                    "fontStyle": "normal",
                    "fontWeight": "normal"
                }
            },
            "splitArea": {"show": false, "areaStyle": {"color": ["rgba(250,250,250,0.3)", "rgba(200,200,200,0.3)"]}}
        }],
        "series": [{
            "name": "我的表现",
            "type": "bar",
            "barCategoryGap": 140,
            "data": [2294],
            "clickable": true,
            "legendHoverLink": true,
            "xAxisIndex": 0,
            "yAxisIndex": 0,
            "barMinHeight": 0,
            "barGap": "30%",
            "itemStyle": {
                "normal": {
                    "barBorderColor": "#fff",
                    "barBorderRadius": 0,
                    "barBorderWidth": 0,
                    "label": {"show": false}
                },
                "emphasis": {
                    "barBorderColor": "#fff",
                    "barBorderRadius": 0,
                    "barBorderWidth": 0,
                    "label": {"show": false}
                }
            }
        }, {
            "name": "同行平均",
            "type": "bar",
            "data": [67617],
            "clickable": true,
            "legendHoverLink": true,
            "xAxisIndex": 0,
            "yAxisIndex": 0,
            "barMinHeight": 0,
            "barGap": "30%",
            "barCategoryGap": "20%",
            "itemStyle": {
                "normal": {
                    "barBorderColor": "#fff",
                    "barBorderRadius": 0,
                    "barBorderWidth": 0,
                    "label": {"show": false}
                },
                "emphasis": {
                    "barBorderColor": "#fff",
                    "barBorderRadius": 0,
                    "barBorderWidth": 0,
                    "label": {"show": false}
                }
            }
        }, {
            "name": "同行TOP10平均",
            "type": "bar",
            "data": [1386311],
            "clickable": true,
            "legendHoverLink": true,
            "xAxisIndex": 0,
            "yAxisIndex": 0,
            "barMinHeight": 0,
            "barGap": "30%",
            "barCategoryGap": "20%",
            "itemStyle": {
                "normal": {
                    "barBorderColor": "#fff",
                    "barBorderRadius": 0,
                    "barBorderWidth": 0,
                    "label": {"show": false}
                },
                "emphasis": {
                    "barBorderColor": "#fff",
                    "barBorderRadius": 0,
                    "barBorderWidth": 0,
                    "label": {"show": false}
                }
            }
        }],
        "DRAG_ENABLE_TIME": 120,
        "symbolList": ["circle", "rectangle", "triangle", "diamond", "emptyCircle", "emptyRectangle", "emptyTriangle", "emptyDiamond"],
        "addDataAnimation": true,
        "animationEasing": "ExponentialOut",
        "animationDuration": 2000,
        "animationThreshold": 2000,
        "animation": true,
        "valueConnector": ": ",
        "nameConnector": " & ",
        "calculableHolderColor": "#ccc",
        "calculableColor": "rgba(255,165,0,0.6)",
        "backgroundColor": "rgba(0,0,0,0)",
        "dataZoom": {
            "show": false,
            "orient": "horizontal",
            "backgroundColor": "rgba(0,0,0,0)",
            "dataBackgroundColor": "#eee",
            "fillerColor": "rgba(144,197,237,0.2)",
            "handleColor": "rgba(70,130,180,0.8)",
            "showDetail": true,
            "realtime": true
        },
        "island": {
            "r": 15,
            "calculateStep": 0.1
        }
    };

    var infoChartConfig = {
        "calculable": true,
        "color": ["#ff7519", "#00B5B6"],
        "legend": {
            "data": ["我的表现", "同行TOP10平均"],
            "orient": "horizontal",
            "show": true,
            "x": "center",
            "y": "bottom",
            "backgroundColor": "rgba(0,0,0,0)",
            "borderColor": "#ccc",
            "borderWidth": 0,
            "padding": [5, 5, 5, 5],
            "itemGap": 10,
            "itemWidth": 20,
            "itemHeight": 14,
            "textStyle": {"color": "#333"},
            "selectedMode": true
        },
        "polar": [{
            "radius": "60%",
            "indicator": [{"max": 100, "text": "产品"}, {"max": 100, "text": "旺铺"}, {"max": 100, "text": "曝光"}],
            "center": ["50%", "50%"],
            "startAngle": 90,
            "splitNumber": 5,
            "name": {"show": true, "textStyle": {"color": "#333"}},
            "axisLine": {"show": true, "lineStyle": {"color": "#ccc", "width": 1, "type": "solid"}},
            "axisLabel": {"show": false, "textStyle": {"color": "#333"}},
            "splitArea": {"show": true, "areaStyle": {"color": ["rgba(250,250,250,0.3)", "rgba(200,200,200,0.3)"]}},
            "splitLine": {"show": true, "lineStyle": {"width": 1, "color": "#ccc"}},
            "type": "polygon",
            "__ecIndicator": [{
                "vector": [5.5109105961630896e-15, -90],
                "text": "产品",
                "value": {"max": 100, "min": 0}
            }, {
                "vector": [-77.9422863405995, 44.99999999999997],
                "text": "旺铺",
                "value": {"max": 100, "min": 0}
            }, {"vector": [77.94228634059945, 45.00000000000004], "text": "曝光", "value": {"max": 100, "min": 0}}]
        }],
        "series": [{
            "itemStyle": {
                "normal": {
                    "areaStyle": {"type": "default"},
                    "label": {"show": false},
                    "lineStyle": {"width": 2, "type": "solid"}
                }, "emphasis": {"label": {"show": false}}
            },
            "type": "radar",
            "data": [{
                "name": "我的表现",
                "value": [29.720000000000002, 61.96, 59.45]
            },
                {
                    "name": "同行TOP10平均",
                    "value": [99.42999999999999, 99.42999999999999, 99.42999999999999]
                }],
            "clickable": true,
            "legendHoverLink": true,
            "polarIndex": 0,
            "symbolSize": 2
        }],
        "tooltip": {
            "trigger": "axis",
            "show": true,
            "showContent": true,
            "islandFormatter": "{a} <br/>{b} : {c}",
            "showDelay": 20,
            "hideDelay": 100,
            "transitionDuration": 0.4,
            "backgroundColor": "rgba(0,0,0,0.7)",
            "borderColor": "#333",
            "borderRadius": 4,
            "borderWidth": 0,
            "padding": [5, 5, 5, 5],
            "axisPointer": {
                "type": "line",
                "lineStyle": {"color": "#48b", "width": 2, "type": "solid"},
                "crossStyle": {"color": "#1e90ff", "width": 1, "type": "dashed"},
                "shadowStyle": {"color": "rgba(150,150,150,0.3)", "width": "auto", "type": "default"}
            },
            "textStyle": {
                "color": "#fff",
                "decoration": "none",
                "fontFamily": "Arial, Verdana, sans-serif",
                "fontFamily2": "微软雅黑",
                "fontSize": 12,
                "fontStyle": "normal",
                "fontWeight": "normal"
            },
            "formatter": function (p, e, i) {
                var title = '';
                var m = '';
                var t = '';
                switch (p[0].indicator) {
                    case '产品':
                        title = '产品信息质量分';
                        m = '4.3';
                        t = '4.7';
                        break;
                    case '曝光':
                        title = '总曝光词数（近30天）';
                        m = '5305';
                        t = '46694';
                        break;
                    case '旺铺':
                        title = '旺铺转化率（近30天）';
                        m = '2.3%';
                        t = '9.2%';
                        break;
                }
                var a = '<div style="text-align:center;">' + title + "</div>";
                a += '<div style="padding-top:6px;"><span style="width: 8px;height: 8px;display:inline-block;border-radius:4px;position:relative;top:0;margin-right:8px;"></span>' + p[0].name + ": " + m + "</div>";
                a += '<div style="padding-top:6px;"><span style="width: 8px;height: 8px;display:inline-block;border-radius:4px;position:relative;top:0;margin-right:8px;"></span>' + p[1].name + ": " + t + "</div>";
                return a;
            }
        },
        "DRAG_ENABLE_TIME": 120,
        "symbolList": ["circle", "rectangle", "triangle", "diamond", "emptyCircle", "emptyRectangle", "emptyTriangle", "emptyDiamond"],
        "addDataAnimation": true,
        "animationEasing": "ExponentialOut",
        "animationDuration": 2000,
        "animationThreshold": 2000,
        "animation": true,
        "valueConnector": ": ",
        "nameConnector": " & ",
        "calculableHolderColor": "#ccc",
        "calculableColor": "rgba(255,165,0,0.6)",
        "backgroundColor": "rgba(0,0,0,0)",
        "island": {"r": 15, "calculateStep": 0.1},
        "toolbox": {
            "show": false,
            "orient": "horizontal",
            "x": "right",
            "y": "top",
            "color": ["#1e90ff", "#22bb22", "#4b0082", "#d2691e"],
            "disableColor": "#ddd",
            "effectiveColor": "red",
            "backgroundColor": "rgba(0,0,0,0)",
            "borderColor": "#ccc",
            "borderWidth": 0,
            "padding": [5, 5, 5, 5],
            "itemGap": 10,
            "itemSize": 16,
            "showTitle": true,
            "feature": {
                "mark": {
                    "show": false,
                    "title": {"mark": "辅助线开关", "markUndo": "删除辅助线", "markClear": "清空辅助线"},
                    "lineStyle": {"width": 1, "color": "#1e90ff", "type": "dashed"}
                },
                "dataZoom": {"show": false, "title": {"dataZoom": "区域缩放", "dataZoomReset": "区域缩放后退"}},
                "dataView": {
                    "show": false,
                    "title": "数据视图",
                    "readOnly": false,
                    "lang": ["Data View", "close", "refresh"]
                },
                "magicType": {
                    "show": false,
                    "title": {"line": "折线图切换", "bar": "柱形图切换", "stack": "堆积", "tiled": "平铺"},
                    "type": []
                },
                "restore": {"show": false, "title": "还原"},
                "saveAsImage": {"show": false, "title": "保存为图片", "type": "png", "lang": ["点击保存"]}
            }
        }
    };

    var busGetChartConfig = {
        "calculable": true,
        "color": ["#ff7519", "#00B5B6"],
        "legend": {
            "data": ["我的表现", "同行TOP10平均"],
            "orient": "horizontal",
            "show": true,
            "x": "center",
            "y": "bottom",
            "backgroundColor": "rgba(0,0,0,0)",
            "borderColor": "#ccc",
            "borderWidth": 0,
            "padding": [5, 5, 5, 5],
            "itemGap": 10,
            "itemWidth": 20,
            "itemHeight": 14,
            "textStyle": {"color": "#333"},
            "selectedMode": true
        },
        "polar": [{
            "radius": "60%",
            "indicator": [{"max": 100, "text": "点击"}, {"max": 100, "text": "反馈"}, {"max": 100, "text": "客户"}],
            "center": ["50%", "50%"],
            "startAngle": 90,
            "splitNumber": 5,
            "name": {"show": true, "textStyle": {"color": "#333"}},
            "axisLine": {"show": true, "lineStyle": {"color": "#ccc", "width": 1, "type": "solid"}},
            "axisLabel": {"show": false, "textStyle": {"color": "#333"}},
            "splitArea": {"show": true, "areaStyle": {"color": ["rgba(250,250,250,0.3)", "rgba(200,200,200,0.3)"]}},
            "splitLine": {"show": true, "lineStyle": {"width": 1, "color": "#ccc"}},
            "type": "polygon",
            "__ecIndicator": [{
                "vector": [5.5109105961630896e-15, -90],
                "text": "点击",
                "value": {"max": 100, "min": 0}
            }, {
                "vector": [-77.9422863405995, 44.99999999999997],
                "text": "反馈",
                "value": {"max": 100, "min": 0}
            }, {"vector": [77.94228634059945, 45.00000000000004], "text": "客户", "value": {"max": 100, "min": 0}}]
        }],
        "series": [{
            "itemStyle": {
                "normal": {
                    "areaStyle": {"type": "default"},
                    "label": {"show": false},
                    "lineStyle": {"width": 2, "type": "solid"}
                }, "emphasis": {"label": {"show": false}}
            },
            "type": "radar",
            "data": [{"name": "我的表现", "value": [73.68, 77.33, 50.88]}, {
                "name": "同行TOP10平均",
                "value": [99.42999999999999, 99.42999999999999, 99.42999999999999]
            }],
            "clickable": true,
            "legendHoverLink": true,
            "polarIndex": 0,
            "symbolSize": 2
        }],
        "DRAG_ENABLE_TIME": 120,
        "symbolList": ["circle", "rectangle", "triangle", "diamond", "emptyCircle", "emptyRectangle", "emptyTriangle", "emptyDiamond"],
        "addDataAnimation": true,
        "animationEasing": "ExponentialOut",
        "animationDuration": 2000,
        "animationThreshold": 2000,
        "animation": true,
        "valueConnector": ": ",
        "nameConnector": " & ",
        "calculableHolderColor": "#ccc",
        "calculableColor": "rgba(255,165,0,0.6)",
        "backgroundColor": "rgba(0,0,0,0)",
        "island": {"r": 15, "calculateStep": 0.1},
        "toolbox": {
            "show": false,
            "orient": "horizontal",
            "x": "right",
            "y": "top",
            "color": ["#1e90ff", "#22bb22", "#4b0082", "#d2691e"],
            "disableColor": "#ddd",
            "effectiveColor": "red",
            "backgroundColor": "rgba(0,0,0,0)",
            "borderColor": "#ccc",
            "borderWidth": 0,
            "padding": [5, 5, 5, 5],
            "itemGap": 10,
            "itemSize": 16,
            "showTitle": true,
            "feature": {
                "mark": {
                    "show": false,
                    "title": {"mark": "辅助线开关", "markUndo": "删除辅助线", "markClear": "清空辅助线"},
                    "lineStyle": {"width": 1, "color": "#1e90ff", "type": "dashed"}
                },
                "dataZoom": {"show": false, "title": {"dataZoom": "区域缩放", "dataZoomReset": "区域缩放后退"}},
                "dataView": {
                    "show": false,
                    "title": "数据视图",
                    "readOnly": false,
                    "lang": ["Data View", "close", "refresh"]
                },
                "magicType": {
                    "show": false,
                    "title": {"line": "折线图切换", "bar": "柱形图切换", "stack": "堆积", "tiled": "平铺"},
                    "type": []
                },
                "restore": {"show": false, "title": "还原"},
                "saveAsImage": {"show": false, "title": "保存为图片", "type": "png", "lang": ["点击保存"]}
            }
        },
        "tooltip": {
            "trigger": "axis",
            "show": true,
            "showContent": true,
            "islandFormatter": "{a} <br/>{b} : {c}",
            "showDelay": 20,
            "hideDelay": 100,
            "transitionDuration": 0.4,
            "backgroundColor": "rgba(0,0,0,0.7)",
            "borderColor": "#333",
            "borderRadius": 4,
            "borderWidth": 0,
            "padding": [5, 5, 5, 5],
            "axisPointer": {
                "type": "line",
                "lineStyle": {"color": "#48b", "width": 2, "type": "solid"},
                "crossStyle": {"color": "#1e90ff", "width": 1, "type": "dashed"},
                "shadowStyle": {"color": "rgba(150,150,150,0.3)", "width": "auto", "type": "default"}
            },
            "textStyle": {
                "color": "#fff",
                "decoration": "none",
                "fontFamily": "Arial, Verdana, sans-serif",
                "fontFamily2": "微软雅黑",
                "fontSize": 12,
                "fontStyle": "normal",
                "fontWeight": "normal"
            },
            "formatter": function (p, e, i) {
                var title = '';
                var m = '';
                var t = '';
                switch (p[0].indicator) {
                    case '点击':
                        title = '点击率（近30天）';
                        m = '0.41%';
                        t = '1.92%';
                        break;
                    case '客户':
                        title = '总访客数（近30天）';
                        m = '445';
                        t = '9817';
                        break;
                    case '反馈':
                        title = '总反馈数（近30天）';
                        m = '17';
                        t = '849';
                        break;
                }
                var a = '<div style="text-align:center;">' + title + "</div>";
                a += '<div style="padding-top:6px;"><span style="width: 8px;height: 8px;display:inline-block;border-radius:4px;position:relative;top:0;margin-right:8px;"></span>' + p[0].name + ": " + m + "</div>";
                a += '<div style="padding-top:6px;"><span style="width: 8px;height: 8px;display:inline-block;border-radius:4px;position:relative;top:0;margin-right:8px;"></span>' + p[1].name + ": " + t + "</div>";
                return a;
            }
        }
    };

    var busHandChartConfig = {
        "calculable": true,
        "color": ["#ff7519", "#00B5B6"],
        "legend": {
            "data": ["我的表现", "同行TOP10平均"],
            "orient": "horizontal",
            "show": true,
            "x": "center",
            "y": "bottom",
            "backgroundColor": "rgba(0,0,0,0)",
            "borderColor": "#ccc",
            "borderWidth": 0,
            "padding": [5, 5, 5, 5],
            "itemGap": 10,
            "itemWidth": 20,
            "itemHeight": 14,
            "textStyle": {"color": "#333"},
            "selectedMode": true
        },
        "polar": [{
            "radius": "60%",
            "indicator": [{"max": 100, "text": "买家沟通"}, {"max": 100, "text": "订单转化"}, {"max": 100, "text": "RFQ"}],
            "center": ["50%", "50%"],
            "startAngle": 90,
            "splitNumber": 5,
            "name": {"show": true, "textStyle": {"color": "#333"}},
            "axisLine": {"show": true, "lineStyle": {"color": "#ccc", "width": 1, "type": "solid"}},
            "axisLabel": {"show": false, "textStyle": {"color": "#333"}},
            "splitArea": {"show": true, "areaStyle": {"color": ["rgba(250,250,250,0.3)", "rgba(200,200,200,0.3)"]}},
            "splitLine": {"show": true, "lineStyle": {"width": 1, "color": "#ccc"}},
            "type": "polygon",
            "__ecIndicator": [{
                "vector": [5.5109105961630896e-15, -90],
                "text": "买家沟通",
                "value": {"max": 100, "min": 0}
            }, {
                "vector": [-77.9422863405995, 44.99999999999997],
                "text": "订单转化",
                "value": {"max": 100, "min": 0}
            }, {"vector": [77.94228634059945, 45.00000000000004], "text": "RFQ", "value": {"max": 100, "min": 0}}]
        }],
        "series": [{
            "itemStyle": {
                "normal": {
                    "areaStyle": {"type": "default"},
                    "label": {"show": false},
                    "lineStyle": {"width": 2, "type": "solid"}
                }, "emphasis": {"label": {"show": false}}
            },
            "type": "radar",
            "data": [{"name": "我的表现", "value": [44.96, 0, 89.29]}, {
                "name": "同行TOP10平均",
                "value": [99.42999999999999, 99.42999999999999, 99.42999999999999]
            }],
            "clickable": true,
            "legendHoverLink": true,
            "polarIndex": 0,
            "symbolSize": 2
        }],
        "tooltip": {
            "trigger": "axis",
            "show": true,
            "showContent": true,
            "islandFormatter": "{a} <br/>{b} : {c}",
            "showDelay": 20,
            "hideDelay": 100,
            "transitionDuration": 0.4,
            "backgroundColor": "rgba(0,0,0,0.7)",
            "borderColor": "#333",
            "borderRadius": 4,
            "borderWidth": 0,
            "padding": [5, 5, 5, 5],
            "axisPointer": {
                "type": "line",
                "lineStyle": {"color": "#48b", "width": 2, "type": "solid"},
                "crossStyle": {"color": "#1e90ff", "width": 1, "type": "dashed"},
                "shadowStyle": {"color": "rgba(150,150,150,0.3)", "width": "auto", "type": "default"}
            },
            "textStyle": {
                "color": "#fff",
                "decoration": "none",
                "fontFamily": "Arial, Verdana, sans-serif",
                "fontFamily2": "微软雅黑",
                "fontSize": 12,
                "fontStyle": "normal",
                "fontWeight": "normal"
            },
            "formatter": function (p, e, i) {
                var title = '';
                var m = '';
                var t = '';
                switch (p[0].indicator) {
                    case '买家沟通':
                        title = '及时回复率';
                        m = '84.6%';
                        t = '100.0%';
                        break;
                    case 'RFQ':
                        title = 'RFQ市场表现分';
                        m = '586';
                        t = '685';
                        break;
                    case '订单转化':
                        title = '订单转化率（近180天）';
                        m = '0.0%';
                        t = '14.9%';
                        break;
                }
                var a = '<div style="text-align:center;">' + title + "</div>";
                a += '<div style="padding-top:6px;"><span style="width: 8px;height: 8px;display:inline-block;border-radius:4px;position:relative;top:0;margin-right:8px;"></span>' + p[0].name + ": " + m + "</div>";
                a += '<div style="padding-top:6px;"><span style="width: 8px;height: 8px;display:inline-block;border-radius:4px;position:relative;top:0;margin-right:8px;"></span>' + p[1].name + ": " + t + "</div>";
                return a;
            }
        },
        "DRAG_ENABLE_TIME": 120,
        "symbolList": ["circle", "rectangle", "triangle", "diamond", "emptyCircle", "emptyRectangle", "emptyTriangle", "emptyDiamond"],
        "addDataAnimation": true,
        "animationEasing": "ExponentialOut",
        "animationDuration": 2000,
        "animationThreshold": 2000,
        "animation": true,
        "valueConnector": ": ",
        "nameConnector": " & ",
        "calculableHolderColor": "#ccc",
        "calculableColor": "rgba(255,165,0,0.6)",
        "backgroundColor": "rgba(0,0,0,0)",
        "island": {"r": 15, "calculateStep": 0.1},
        "toolbox": {
            "show": false,
            "orient": "horizontal",
            "x": "right",
            "y": "top",
            "color": ["#1e90ff", "#22bb22", "#4b0082", "#d2691e"],
            "disableColor": "#ddd",
            "effectiveColor": "red",
            "backgroundColor": "rgba(0,0,0,0)",
            "borderColor": "#ccc",
            "borderWidth": 0,
            "padding": [5, 5, 5, 5],
            "itemGap": 10,
            "itemSize": 16,
            "showTitle": true,
            "feature": {
                "mark": {
                    "show": false,
                    "title": {"mark": "辅助线开关", "markUndo": "删除辅助线", "markClear": "清空辅助线"},
                    "lineStyle": {"width": 1, "color": "#1e90ff", "type": "dashed"}
                },
                "dataZoom": {"show": false, "title": {"dataZoom": "区域缩放", "dataZoomReset": "区域缩放后退"}},
                "dataView": {
                    "show": false,
                    "title": "数据视图",
                    "readOnly": false,
                    "lang": ["Data View", "close", "refresh"]
                },
                "magicType": {
                    "show": false,
                    "title": {"line": "折线图切换", "bar": "柱形图切换", "stack": "堆积", "tiled": "平铺"},
                    "type": []
                },
                "restore": {"show": false, "title": "还原"},
                "saveAsImage": {"show": false, "title": "保存为图片", "type": "png", "lang": ["点击保存"]}
            }
        }
    };

    // 产品概览
    var prodOverviewConfig = {
        tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b}: {c} ({d}%)",
            backgroundColor: 'rgba(255,255,255,0.7)',
            borderColor: 'rgb(222, 222, 222)',
            borderWidth: 1,
            padding: [5, 20],
            textStyle: {
                color: '#666',
                align: 'center'
            }
        },
        color: ['#1686cc', '#ff6600'],
        series: [
            {
                name: '我的产品',
                type: 'pie',
                selectedMode: 'single',
                radius: ['15%', '50%'],
                avoidLabelOverlap: false,
                startAngle: 320,
                label: {
                    normal: {
                        position: 'outside',
                        formatter: '{per|{d}%}\n {b|{b}}',
                        backgroundColor: '#fff',
                        borderColor: '#fff',
                        borderWidth: 0,
                        borderRadius: 4,
                        lineHeight: 20,
                        padding: [5, 10],
                        rich: {
                            b: {
                                fontSize: 12,
                                lineHeight: 33,
                                color: '#666'
                            },
                            per: {
                                color: '#666',
                                backgroundColor: '#fff',
                                padding: [2, 4],
                                borderRadius: 2
                            }
                        }
                    }
                },
                labelLine: {
                    normal: {
                        show: false
                    }
                },
                data: [
                    {value: 1136, name: '近15天有效果产品'},
                    {value: 224, name: '零效果产品'}
                ]
            }
        ]
    };

    // 零效果产品
    var noResultProdConfig = {
        tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b}: {c} ({d}%)",
            backgroundColor: 'rgba(255,255,255,0.7)',
            borderColor: 'rgb(222, 222, 222)',
            borderWidth: 1,
            padding: [5, 20],
            textStyle: {
                color: '#666',
                align: 'center'
            }
        },
        color: ['#1686cc', '#14caca', '#01b18d', '#ff6600'],
        series: [
            {
                name: '无效时长',
                type: 'pie',
                selectedMode: 'single',
                radius: ['15%', '50%'],
                avoidLabelOverlap: false,
                startAngle: 320,
                label: {
                    normal: {
                        position: 'outside',
                        formatter: '{per|{d}%}\n {b|{b}}',
                        backgroundColor: '#fff',
                        borderColor: '#fff',
                        borderWidth: 0,
                        borderRadius: 4,
                        lineHeight: 20,
                        padding: [0, 10],
                        rich: {
                            b: {
                                fontSize: 12,
                                lineHeight: 33,
                                color: '#666'
                            },
                            per: {
                                color: '#666',
                                backgroundColor: '#fff',
                                padding: [0, 4],
                                borderRadius: 2
                            }
                        }
                    }
                },
                labelLine: {
                    normal: {
                        show: false
                    }
                },
                data: [
                    {value: 112, name: '15~29天'},
                    {value: 45, name: '30~59天'},
                    {value: 35, name: '60~89天'},
                    {value: 30, name: '90~179天'}
                ]
            }
        ]
    };

    // 询盘曝光
    var inqExposureConfig = {
        color: ['#3398DB'],
        // tooltip : {
        //     trigger: 'axis',
        //     axisPointer : {            // 坐标轴指示器，坐标轴触发有效
        //         type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
        //     }
        // },
        grid: {
            x: 60,
            y: 20,
            x2: 30,
            y2: 20
        },
        xAxis: [
            {
                type: 'category',
                data: ['TOP10平均曝光增幅', '平均曝光增幅'],
                axisTick: {
                    alignWithLabel: true
                }
            }
        ],
        yAxis: [
            {
                type: 'value',
                max: 3265,
                splitNumber: 5,
                minInterval: Math.round(3265 / 5),
                axisLabel: {
                    show: true,
                    interval: 'auto',
                    formatter: '{value} %'
                }
            }
        ],
        series: [
            {
                name: '曝光增幅',
                type: 'bar',
                barWidth: '60%',
                data: [3261, 62],
                label: {
                    normal: {
                        show: true,
                        position: 'outside',
                        formatter: '{per|{c}%}',
                        rich: {
                            per: {
                                color: '#666'
                            }
                        }
                    }
                }
            }
        ]
    };

    // 询盘反馈
    var inqFbConfig = {
        color: ['#3398DB'],
        grid: {
            x: 60,
            y: 20,
            x2: 30,
            y2: 20
        },
        xAxis: [
            {
                type: 'category',
                data: ['TOP10平均反馈增幅', '平均反馈增幅'],
                axisTick: {
                    alignWithLabel: true
                }
            }
        ],
        yAxis: [
            {
                type: 'value',
                max: 1615,
                splitNumber: 5,
                minInterval: Math.round(1615 / 5),
                axisLabel: {
                    show: true,
                    interval: 'auto',
                    formatter: '{value} %'
                }
            }
        ],
        series: [
            {
                name: '反馈增幅',
                type: 'bar',
                barWidth: '60%',
                data: [1615, 45],
                label: {
                    normal: {
                        show: true,
                        position: 'outside',
                        formatter: '{per|{c}%}',
                        rich: {
                            per: {
                                color: '#666'
                            }
                        }
                    }
                }
            }
        ]
    };

    // 数据看板
    var realtimeConfig = {
        color: ['#cecfd2', '#1c90ff'],
        tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgb(255, 255, 255, .8)',
            textStyle: {
                color: '#999999'
            },
            axisPointer: {
                type: 'line'
            }
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: [],
            // data: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
            axisLine: {
                lineStyle: {
                    color: '#dedede'
                }
            },
            axisLabel: {
                interval: function(index, value) {
                    return (index % 6 === 0 && index !== 24) || index === 23;
                },
                color: '#999999'
            }
        },
        yAxis: {
            show: false
        },
        grid: {
            left: '5%'
        },
        series: [{
            name: '昨日',
            showSymbol: false,
            data: [],
            // data: [1, 4, 5, 7, 8, 9, 10, 13, 15, 17, 19, 21, 23, 25, 27, 30, 30, 31, 32, 34, 36, 38, 39, 40],
            type: 'line',
            smooth: true
        }, {
            name: '今日',
            showSymbol: false,
            data: [],
            // data: [17, 47, 57, 72, 84, 94, 104, 138, 157, 172, 190, 217, 237, 258, 278, 300, 303, 314, 326, 347, 367, 382, 395, 403],
            type: 'line',
            smooth: true,
            areaStyle: {
                normal: {
                    color: new echartsV3.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#79befe'
                    }, {
                        offset: 1,
                        color: '#ffffff'
                    }])
                }
            }
        }]
    };

    var previousConfig = {
        color: ['#1c90ff'],
        tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgb(255, 255, 255, .8)',
            textStyle: {
                color: '#999999'
            },
            axisPointer: {
                type: 'line'
            }
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: [],
            // data: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
            axisLine: {
                lineStyle: {
                    color: '#dedede'
                }
            }
        },
        yAxis: {
            show: false
        },
        grid: {
            left: '5%'
        },
        series: [{
            name: '店铺访问人数',
            showSymbol: false,
            data: [],
            // data: [17, 47, 57, 72, 84, 94, 104, 138, 157, 172, 190, 217, 237, 258, 278, 300, 303, 314, 326, 347, 367, 382, 395, 403],
            type: 'line',
            smooth: true,
            areaStyle: {
                normal: {
                    color: new echartsV3.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#79befe'
                    }, {
                        offset: 1,
                        color: '#ffffff'
                    }])
                }
            }
        }]
    };

    // 经营数据
    var summaryConfig = {
        color: ['#1c90ff', '#2fc25b', '#facc14'],
        tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgb(255, 255, 255, .8)',
            textStyle: {
                color: '#999999'
            },
            axisPointer: {
                type: 'line'
            }
        },
        legend: {
            x: 'center',
            y: 'bottom',
            align: 'left',
            selectedMode: false,
            data: [
                {name: '我的效果', icon: 'pin', textStyle: {color: '#999999'}},
                {name: '行业平均', icon: 'pin', textStyle: {color: '#999999'}},
                {name: '同行优秀', icon: 'pin', textStyle: {color: '#999999'}}
            ]
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: [],
            // data: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
            axisLine: {
                lineStyle: {
                    color: '#dedede'
                }
            },
            axisLabel: {
                interval: 6,
                color: '#666666'
            }
        },
        yAxis: {
            show: true,
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            axisLabel: {
                color: '#666666'
            },
            splitLine: {
                lineStyle: {
                    type: 'dotted'
                }
            }
        },
        grid: {
            top: '30'
        },
        series: [{
            name: '我的效果',
            showSymbol: false,
            data: [],
            // data: [17, 47, 57, 72, 84, 94, 104, 138, 157, 172, 190, 217, 237, 258, 278, 300, 303, 314, 326, 347, 367, 382, 395, 403],
            type: 'line',
            smooth: true,
            itemStyle: {
                color: '#1c90ff'
            },
            areaStyle: {
                normal: {
                    color: new echartsV3.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#79befe'
                    }, {
                        offset: 1,
                        color: '#ffffff'
                    }])
                }
            }
        }, {
            name: '行业平均',
            showSymbol: false,
            data: [],
            // data: [7, 7, 7, 2, 4, 4, 4, 8, 7, 2, 0, 7, 7, 8, 8, 0, 3, 4, 6, 7, 7, 2, 5, 3],
            type: 'line',
            smooth: true,
            itemStyle: {
                color: '#2fc25b'
            }
        }, {
            name: '同行优秀',
            showSymbol: false,
            data: [],
            // data: [1, 4, 5, 7, 8, 9, 10, 13, 15, 17, 19, 21, 23, 25, 27, 30, 30, 31, 32, 34, 36, 38, 39, 40],
            type: 'line',
            smooth: true,
            itemStyle: {
                color: '#facc14'
            }
        }]
    };

    // 国家及地区分析
    var analysisConfig = {
        color: ['#1890ff', '#13c2c2', '#2fc25b', '#facc14', '#f04864', '#8543e0', '#3436c7', '#223273'],
        title : {
            text: '',
            textStyle: {
                color: '#999999',
                fontSize: '14px'
            }
        },
        tooltip: {
            trigger: 'item',
            formatter: "{b}: {d}%",
            backgroundColor: 'rgb(255, 255, 255, .8)',
            textStyle: {
                color: '#999999'
            }
        },
        legend: {
            orient: 'vertical',
            x: 'right',
            y: 'middle',
            align: 'left',
            selectedMode: false,
            data: [
                // {name: 'Europe', icon: 'pin'},
                // {name: 'North America', icon: 'pin'},
                // {name: 'Asia', icon: 'pin'},
                // {name: 'Middle East', icon: 'pin'},
                // {name: 'South America', icon: 'pin'},
                // {name: 'Africa', icon: 'pin'},
                // {name: 'Oceania', icon: 'pin'},
                // {name: 'Other', icon: 'pin'}
            ]
        },
        series: [
            {
                name: '',
                type: 'pie',
                hoverAnimation: false,
                selectedMode: 'single',
                radius: ['25%', '40%'],
                avoidLabelOverlap: false,
                label: {
                    normal: {
                        show: true,
                        position: 'outside',
                        formatter: '{b}: {d}%',
                        color: '#999999'
                    }
                },
                labelLine: {
                    normal: {
                        show: true
                    }
                },
                itemStyle: {
                    borderColor: '#ffffff'
                },
                data: [
                    // {value: 0.3537, name: 'Europe'},
                    // {value: 0.1636, name: 'North America'},
                    // {value: 0.1405, name: 'Asia'},
                    // {value: 0.1124, name: 'Middle East'},
                    // {value: 0.1091, name: 'South America'},
                    // {value: 0.0694, name: 'Africa'},
                    // {value: 0.0347, name: 'Oceania'},
                    // {value: 0.0165, name: 'Other'}
                ]
            }
        ]
    };

    angular
        .module('app.core')
        .constant('infoDisplayConfig', infoDisplayConfig)
        .constant('busObtainConfig', busObtainConfig)
        .constant('busHandleConfig', busHandleConfig)
        .constant('onlineTradingConfig', onlineTradingConfig)
        .constant('prodOverviewConfig', prodOverviewConfig)
        .constant('noResultProdConfig', noResultProdConfig)
        .constant('inqExposureConfig', inqExposureConfig)
        .constant('inqFbConfig', inqFbConfig)
        .constant('onlineChartConfig', onlineChartConfig)
        .constant('infoChartConfig', infoChartConfig)
        .constant('busGetChartConfig', busGetChartConfig)
        .constant('busHandChartConfig', busHandChartConfig)
        .constant('realtimeConfig', realtimeConfig)
        .constant('previousConfig', previousConfig)
        .constant('summaryConfig', summaryConfig)
        .constant('analysisConfig', analysisConfig)


})();